<template>
  <teleport to="body">
    <transition :name="transition">
      <div v-show="showDrawer" ref="content" v-resize="{disable:!resizable,geometric:resizable===true,transform:'offset'}" class="SpDrawer-content" :style="style" :class="classes">
        <div v-if="dragable" v-drag="{target:1,disable:!dragable,transform:false}" class="drag-dialog" />
        <SpIcon v-if="showClose" class="close-icon pointer" :type="closeIcon" width="13" @click="showDrawer=false" />
        <div class="title"><slot name="title"><p v-if="title" class="fs-bold">{{ title }}</p></slot></div>
        <SpScroll class="main" :width="1" :height="1" :show-scroll="showScroll"><slot /></SpScroll>
        <div class="footer">
          <slot name="footer">
            <div v-if="type=='confirm'" class="flex-jc-ard">
              <SpButton circle type="cancleLight" :width="134" :height="53" @click="showDrawer=false">{{ $l('Cancle') }}</SpButton>
              <SpButton circle type="confirm" :width="134" :height="53">{{ $l('Confirm') }}</SpButton>
            </div>
          </slot>
        </div>
      </div>
    </transition>
    <div v-show="showDrawer" class="SpDrawer-mask" :style="{zIndex:zIndex}" :class="{'sp-mask':mask}" @click.capture="clickOutside" />
  </teleport>
</template>

<script type="text/ecmascript-6">
import SpIcon from './SpIcon.vue'
import zIndexManager from '@/utils/zIndexManager'
import SpScroll from '@/components/common/SpScroll'
import SpButton from './SpButton.vue'
import drag from '@/directives/drag'
import resize from '@/directives/resize'
export default {
  name: 'SpDrawer',

  nameSpace: 'SpDrawer',
  components: {
    SpIcon,
    SpScroll,
    SpButton
  },

  // inject: ['PopupTrigger'],
  directives: { drag, resize },
  props: {
    modelValue: Boolean,
    direction: {
      type: String,
      default: 'center'
    },

    width: {
      type: Number,
      default: 0
    },

    height: {
      type: Number,
      default: 0
    },

    showClose: {
      type: Boolean,
      default: true
    },

    lockScreen: {
      type: Boolean,
      default: true
    },

    closeIcon: {
      type: String,
      default: 'closeBlack'
    },

    mask: {
      type: Boolean,
      default: true
    },

    type: {
      type: String,
      default: 'drawer'
    },

    showScroll: {
      type: Boolean,
      default: true
    },

    title: {
      type: String,
      default: ''
    },

    dragable: Boolean,
    resizable: Boolean,
    closeOnPressEscape: Boolean,
    closeOnClickMask: {
      type: Boolean,
      default: true
    },

    popStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },

    popClass: {
      type: [Array, String],
      default: () => {
        return null
      }
    },

    popupTrigger: {
      type: Object,
      default: () => {
        return null
      }
    },

    offsetTop: {
      type: [Number, String],
      default: 0
    }
  },

  emits: ['update:modelValue'],

  data () {
    return {
      zIndex: 100,
      position: {}
    }
  },

  computed: {

    showDrawer: {
      get () {
        return this.modelValue
      },

      set (nv) {
        this.$emit('update:modelValue', nv)
      }
    },

    transition () {
      switch (this.direction) {
        case 'center':
          return 'tst-scale-center'
        case 'center-offset':
          return 'tst-scale-center-offset'
        case 'left':
          return 'tst-scale-right'
        default:
          return 'tst-scale-center'
      }
    },

    widthC () {
      if (this.width === 0) {
        return 'auto'
      } else if (this.width > 1) {
        return this.width + 'px'
      } else if (this.width < 1) {
        return window.innerWidth * this.width + 'px'
      } else {
        return '100%'
      }
    },

    heightC () {
      if (this.height === 0) {
        return 'auto'
      } else if (this.height > 1) {
        return this.height + 'px'
      } else if (this.height < 1) {
        return window.innerHeight * this.height + 'px'
      } else {
        return '100%'
      }
    },

    classes () {
      let classes = this.popClass || ['primary-style']
      if (typeof classes === 'string') {
        classes = [classes]
      }
      const posClass = {
        'sp-pos-center': this.direction === 'center',
        'sp-pos-center-offset': this.direction === 'center-offset' || this.popupTrigger,
        'sp-pos-left': this.direction === 'left',
        'sp-pos-right': this.direction === 'right',
        'sp-pos-top': this.direction === 'top',
        'sp-pos-bottom': this.direction === 'bottom',
        'sp-dialog': this.type === 'dialog'
      }
      return [posClass, ...classes]
    },

    style () {
      const style = { ...this.popStyle }
      if (!style.width && this.width !== 0) {
        style.width = this.widthC
      }
      if (!style.height && this.height !== 0) {
        style.height = this.heightC
      }
      style.zIndex = style.zIndex || zIndexManager.nextIndex()
      if (this.popupTrigger) {
        if (this.position.left) {
          style.left = `${this.position.left}px`
        }
        if (this.position.right) {
          style.right = `${this.position.right}px`
        }
        if (this.position.top) {
          style.top = `${this.position.top}px`
        }
        if (this.position.bottom) {
          style.bottom = `${this.position.bottom || null}px`
        }

        if (this.position.height) {
          style.height = `${this.position.height}px`
        }
        if (this.position.transform) {
          style.transform = this.position.transform
        }
      }
      return style
    }
  },

  watch: {
    modelValue (nv) { // 控制scroll滑动
      if (nv) {
        // this.zIndex = zIndexManager.nextIndex()// 初始化层级
        if (this.popupTrigger) {
          this.calcPosition()
        }
        if (this.lockScreen) {
          if (document.body.scrollHeight > window.innerHeight) {
            document.body.style.left = '0'
            document.body.style.right = window.innerWidth - document.body.clientWidth + 'px'
            // document.getElementById('app').style.paddingRight = '100px'
          }
          document.body.style.overflow = 'hidden'
        }
        if (this.closeOnPressEscape) { document.addEventListener('keydown', this.onKeyPress) }
      } else {
        document.body.style.right = '0'
        document.body.style.overflow = 'auto'
        if (this.closeOnPressEscape) { document.removeEventListener('keydown', this.onKeyPress) }
      }
    }
  },

  created () {
    this.zIndex = zIndexManager.nextIndex()// 初始化层级
    this.calcPosition()
  },

  mounted () {

  },

  methods: {
    calcPosition () {
      const style = {}
      if (this.popupTrigger) {
        let bottom = this.popupTrigger.$el ? this.popupTrigger.$el.getBoundingClientRect().bottom : this.popupTrigger.getBoundingClientRect().bottom
        bottom += this.offsetTop
        let top = this.popupTrigger.$el ? this.popupTrigger.$el.getBoundingClientRect().top : this.popupTrigger.getBoundingClientRect().top
        top -= this.offsetTop
        style.transform = 'translateX(-50%)'
        if (this.heightC.slice(0, -2) > (window.innerHeight - bottom)) { // 下方不能放下
          if (this.heightC.slice(0, -2) < (top)) { // 上方能放下，放上方
            style.bottom = window.innerHeight - top
          } else if ((window.innerHeight - bottom) < top) { // 上方不能放下，上方区域大于下方区域，放上方，重置高度
            style.bottom = window.innerHeight - top - 40
            style.height = top
          } else { // 上方不能放下，上方区域小于下方区域，放下方，重置高度
            style.top = bottom
            style.height = window.innerHeight - bottom - 40
          }
        } else { // 下方能放下，放下方
          style.top = bottom
        }
      }
      this.position = style
    },

    onKeyPress (e) {
      if (!this.closeOnPressEscape) return
      if (e.code === 'Escape') {
        e.stopPropagation()
        this.closePop()
      }
    },

    closePop () {
      this.showDrawer = false
    },

    clickOutside (e) {
      e.stopPropagation()
      if (this.closeOnClickMask) {
        this.closePop()
      }
    }
  }
}
</script>

<style scoped lang="less">
.sp-mask{
  background:rgba(0, 0, 0, 0.4);
}
.SpDrawer-mask{
  position: fixed;
  top:0;
  left:0;
  width: 100%;
  height: 100%;
}
.SpDrawer-content{
  position: fixed;
  min-width: 20%;
  min-height: 20%;
  .title, .footer{
    margin:0 auto;
    text-align: left;
  }
  .drag-dialog{
    cursor: move;
    min-height: 5px;
    position: absolute;
    top: 0;
    width: 100%;
  }
  .footer{
    margin:@gap 0;
  }
  overflow: hidden;
  >.close-icon{
    // background-color: white;
    position: absolute;
    top:10px;
    right:16px;
    z-index: 99;
  }
  >.content-default{
    background-color: white;
  }

}

.sp-pos-center{
  left: 50%;
  top:50%;
  transform:translate(-50%,-50%);
}

.sp-pos-center-offset{
  left: 50%;
  transform:translateX(-50%);
}

.sp-pos-left{
  left: 0px;
  top:0;
  height:100%;
  // width: 30%;
  min-width: 20%;
}
.sp-pos-right{
  right: 0;
  height:100%;
  width: 30%;
}
.sp-pos-top{
  top: 0;
  width:100%;
  height:30%
}
.sp-pos-bottom{
  bottom: 0;
  width:100%;
  height:30%
}
.sp-dialog{
  background: #FFFFFF;
  box-shadow: 0px 4px 27px 0px rgba(0, 0, 0, 0.25);
}
.primary-style{
  background: #FFFFFF;
  padding: @gap;
}
</style>
